import { Navigate } from "react-router-dom";
import { user_token } from "./tokensStored";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  if (user_token?.user.role === "candidate") {
    // if (user_token?.user.user_meta_info.phone === null)
    //   return <Navigate replace to="/candidate-details" />;
    return <Navigate replace to="/dashboard/candidate" />;
  }
  if (user_token?.user.role === "hiring_manager")
    // if (user_token?.user.user_meta_info.company === null)
    //   return <Navigate replace to="/hiring-manager-onboard" />;
    // else 
    return <Navigate replace to="/dashboard/hiring-manager" />;
  if (user_token?.user.role === "mentor") {
    return <Navigate replace to="/dashboard/mentor" />;
  }
  if (user_token?.user.role === "recruiter") {
    return <Navigate replace to="/dashboard/recruiter" />;
  }
};
